import { render } from "./Question.vue?vue&type=template&id=448f759d"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
script.render = render

export default script